export enum CenterType {
	SESSAD = 1,
	SAAD = 2,
	SSIAD = 3,
	SAE = 4
}

export function getCenterTypeKeyByValue(value: number) {
	const indexOfCompetence = Object.values(CenterType).indexOf(value);
	const key = Object.keys(CenterType)[indexOfCompetence];
	return key;
}
